// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconBubbleMessage = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M7 9h10v2H7zm10 4H7v2h10z" />,
    <path fillRule="evenodd" d="M8 19l-3 3H3V5h18v14zm11-2H7.172L5 19.172V7h14z" />
  );
export default SvgIconBubbleMessage;
